import { gql } from '@apollo/client';

export const stopCharge = gql`
  mutation stopCharge($input: StopChargeInput!) {
    stopCharge(input: $input)
  }
`;
